export default __webpack_public_path__ + "static/804-9d4e8a363813d3f4a962145a66e62650.gif";